<template>
    <div class="card shadow-sm">
        <div class="card-body">
            <h5 class="card-title">
                {{ $t("pages.admin.video.index.filter.filter") }}
            </h5>

            <div class="row ml-0">
                <div class="form-group">
                    <div class="form-check form-check-primary mt-4">
                        <label class="form-check-label">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                v-model="filter.blocked"
                            />
                            {{ $t("pages.admin.users.filter.blocked") }}
                            <i class="input-helper"></i>
                        </label>
                    </div>
                </div>
                <div class="form-group ml-3">
                    <div class="form-check form-check-primary mt-4">
                        <label class="form-check-label">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                v-model="filter.subscribed"
                            />
                            {{ $t("pages.admin.users.filter.subscribed") }}
                            <i class="input-helper"></i>
                        </label>
                    </div>
                </div>
                <div class="form-group ml-3">
                    <div class="form-check form-check-primary mt-4">
                        <label class="form-check-label">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                v-model="filter.health"
                            />
                            {{ $t("pages.admin.users.filter.health") }}
                            <i class="input-helper"></i>
                        </label>
                    </div>
                </div>

                <div class="form-group ml-3">
                    <div class="form-check form-check-primary mt-4">
                        <label class="form-check-label">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                v-model="filter.referred"
                            />
                            {{ $t("pages.admin.users.filter.referred") }}
                            <i class="input-helper"></i>
                        </label>
                    </div>
                </div>
            </div>
            <div class="row ml-0">
                <div class="form-group">
                    <label for="name" class="font-weight-bolder">{{
                        $t("pages.admin.users.filter.user_name")
                    }}</label>
                    <input
                        type="text"
                        class="form-control"
                        id="name"
                        :placeholder="$t('pages.admin.users.filter.user_name')"
                        v-model="name"
                        @input="setName"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UserFilter",
    data: () => ({
        filter: {
            blocked: true,
            subscribed: true,
            referred: false,
            health: false,
            name: null
        },
        name: ""
    }),
    watch: {},
    methods: {
        applyFilter() {
            this.$emit("update:filter", this.filter);
        },
        setName: _.debounce(function() {
            this.filter.name = this.name
        }, 300)
    },

    mounted() {
        this.applyFilter();
    }
};
</script>

<style></style>
